import axios from "axios";
import config from "@/config/constants.js";

export default {
  namespaced: true,
  state: {
    status: "",
    name_owner: "",
    company_name: "",
    tenant_id:"",
    user: {},
    referral: "",
  },
  mutations: {
    referral(state, token) {
      state.referral = token;
    },
    loading(state) {
      state.status = "loading";
    },
    status(state, status) {
      state.status = status;
    },
    nameOwner(state, name) {
      state.name_owner = name;
    },
    nameCompany(state, company_name) {
      state.company_name = company_name;
    },
    tenant(state, tenant) {
      state.tenant_id = tenant;
    },
    recover(state, data_user) {
      state.user = data_user;
    },
    success(state, user = null) {
      state.status = "";
      if (user) {
        state.user = user;
      }
    },
  },
  actions: {
    signup_agent: function ({commit, state}, data) {
      let params = data;
      params['no_owner'] = true;
      params['tenant_id'] = state.tenant_id;
      params['signup_for'] = "agent";
      // Forward the signed invite token so the backend can authorize the
      // activation (captured from the invite link in add_name_owner).
      params['referral'] = state.referral;

      return new Promise(function (resolve, reject) {
        commit("loading");

        axios.post(config.api_url + 'users/me/activate', params)
          .then(() => {
            commit("success", data);
            resolve(data);
          })
          .catch(err => {
            commit("status", "error");
            reject(err.response.data.message);
          })
      });
    },
    add_name_owner: function ({commit}, token) {

      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve, reject) {
        commit('loading');
        let param = {
          "referral": token,
          "signup_for": "agent"
        }
        commit("referral", token);
        await axios.post(config.api_url + 'get_user', param)
          .then(response => {
            commit("nameOwner", response.data.name);
            commit("nameCompany", response.data.company_name);
            commit("tenant", response.data.tenant_id);
            resolve(response);
          })
          .catch(err => {
            reject(err.response.data.message);
          })
        commit("success");
      });
    },
    recover_data: function ({
      commit
    }, data) {
      commit("recover", data);
    },
  },
  getters: {},
  modules: {}
}